<div>
    <nav class="col-lg-3 col-md-4 mt-5 p-2 d-none d-xl-block d-lg-block d-md-block vh-100 overflow-auto bg-warning sidebar-left"> 
        <div class="list-group list-group-flush my-3" *ngIf="peopleLoggedIn">
            <a class="list-group-item text-uppercase font-weight-bolder">User</a>
            <a class="list-group-item list-group-item-action btn" (click)="routeToPeopleDetailPage()">Detail</a>  
        </div>
        <!-- <div class="list-group my-3">
            <a class="list-group-item text-uppercase font-weight-bolder election-header">PNG 2022 Election</a>
            <a class="list-group-item list-group-item-action election-item" (click)="routeToBusinessPopularListPage()" routerLink="">Party</a>
            <a class="list-group-item list-group-item-action election-item" (click)="routeToGovernmentCategoryListPage()" routerLink="">Candidate</a>
            <a class="list-group-item list-group-item-action election-item" (click)="routeToGovernmentCategoryListPage()" routerLink="">Voter</a>
        </div> -->
        <div class="list-group my-3">
            <a class="list-group-item text-uppercase font-weight-bolder">Profile</a>
            <a class="list-group-item list-group-item-action" (click)="routeToPeopleDetailPage()" routerLink="">Personal</a>
            <a class="list-group-item list-group-item-action" (click)="routeToBusinessPopularListPage()" routerLink="">Business</a>
            <a class="list-group-item list-group-item-action" (click)="routeToGovernmentCategoryListPage()" routerLink="">Government</a>
        </div>
        <div class="list-group list-group-flush my-3">
            <a class="list-group-item text-uppercase font-weight-bolder">Travel</a>
            <a class="list-group-item list-group-item-action" (click)="routeToTourpackageListPage()" routerLink="">Tour Package</a>
            <!-- <a class="list-group-item list-group-item-action" (click)="routeToTourpackageListPage()" routerLink="">Tour Operator</a> -->
        </div>
        <div class="list-group my-3">
            <a class="list-group-item text-uppercase font-weight-bolder">Marketplace</a>
            <a class="list-group-item list-group-item-action" (click)="routeToHandicraftListPage()" routerLink="">Handicraft</a>
            <a class="list-group-item list-group-item-action" (click)="routeToPaintingListPage()" routerLink="">Painting</a>
        </div>
    </nav>
</div>